const styles = (theme) => ({
  root:{
    padding:'32px',
  },
  link:{
    cursor:'pointer'
  }
})

export default styles